/* global axios */
import ApiClient from './ApiClient';

class Infobip extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // ── Por inbox_id (settings page) ─────────────────────────────────────────

  getAgents(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/infobip/agents`, { params });
  }

  getQueues(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/infobip/queues`, { params });
  }

  getTags(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/infobip/tags`, { params });
  }

  // ── Por credenciais (formulário de criação) ───────────────────────────────

  getAgentsByCredentials(baseUrl, apiKey, params = {}) {
    return axios.get(`${this.baseUrl()}/infobip/agents`, {
      params: { base_url: baseUrl, api_key: apiKey, ...params },
    });
  }

  getQueuesByCredentials(baseUrl, apiKey, params = {}) {
    return axios.get(`${this.baseUrl()}/infobip/queues`, {
      params: { base_url: baseUrl, api_key: apiKey, ...params },
    });
  }

  getTagsByCredentials(baseUrl, apiKey, params = {}) {
    return axios.get(`${this.baseUrl()}/infobip/tags`, {
      params: { base_url: baseUrl, api_key: apiKey, ...params },
    });
  }

  async fetchConversations(
    identifier,
    { beginDate, endDate, force, updateExisting } = {}
  ) {
    const url = `${this.baseUrl()}/infobip/fetch_conversations`;
    const response = await axios.post(url, {
      identifier,
      begin_date: beginDate,
      end_date: endDate,
      force,
      update_existing: updateExisting,
    });
    return response.data;
  }
}

export default new Infobip();
